import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

interface AdSlotProps {
    id: string;
    width?: number;
    height?: number;
}

// In production, renders an empty container that vendor scripts (e.g. JuicyAds,
// ExoClick) can target via the `data-ad-slot` attribute. In development, shows
// a faint dashed placeholder so layout work is visible.
const Slot = styled.div<{ $w: number; $h: number; $dev: boolean }>`
    width: ${p => p.$w}px;
    height: ${p => p.$h}px;
    margin: ${theme.spacing.sm} auto;
    border: ${p => p.$dev ? `1px dashed ${theme.colors.border}` : 'none'};
    color: ${theme.colors.textSecondary};
    font-size: 0.7rem;
    display: ${p => p.$dev ? 'flex' : 'block'};
    align-items: center;
    justify-content: center;
    text-align: center;
    opacity: ${p => p.$dev ? 0.4 : 1};
`;

const AdSlot: React.FC<AdSlotProps> = ({ id, width = 300, height = 250 }) => {
    const isDev = process.env.NODE_ENV !== 'production';
    return (
        <Slot data-ad-slot={id} $w={width} $h={height} $dev={isDev}>
            {isDev ? `ad: ${id}` : null}
        </Slot>
    );
};

export default AdSlot;
